define([
  "globals",
  "base-view-model",
  "jquery",
  "knockout",
  "underscore",
  "postal",
  "pricing-support",
  "local-storage",
  "knockout-postbox"],
function(globals, baseViewModel, $, ko, _, postal, PricingSupport, LocalStorage) {

  var productPageChannel = postal.channel("productpage");

  var EstimateProductPriceViewModel = function(parentModel, sizeOptions) {
    var self = this;
    var parent = parentModel;
    ko.utils.extend(self, baseViewModel);

    self.defaultPrice = globals.price;
    self.productId = globals.productId;
    self.widthOption = globals.models.widthOption;
    self.heightOption = globals.models.heightOption;
    self.sampleOptions = globals.models.sampleOptions;
    self.oldPricingContext = undefined;

    self.defaults = {
      minWidth: 7,
      maxWidth: 156,
      minHeight: 10,
      maxHeight: 160
    };

    self.sizeOptions = $.extend({}, self.defaults, sizeOptions);
    self.widthDimension = new PricingSupport.WidthDimension(self.sizeOptions.minWidth, self.sizeOptions.maxWidth);
    self.heightDimension = new PricingSupport.HeightDimension(self.sizeOptions.minHeight, self.sizeOptions.maxHeight);

    self.lowPrice = ko.observable(globals.productPrice.LowPrice).publishOn("colorSelectorLowPrice");
    self.highPrice = ko.observable( globals.productPrice.HighPrice ).publishOn( "colorSelectorHighPrice" );
    self.allNA = ko.computed(function() {
      return self.lowPrice() == "N/A" && self.highPrice() == "N/A";
    } );
    self.widthWhole = ko.observable(self.widthDimension.dimension.valueWhole());
    self.heightWhole = ko.observable(self.heightDimension.dimension.valueWhole());
    self.currentChoiceIds = ko.observableArray();
    self.dimensionsAdjustedByServer = ko.observable(globals.dimensionsAdjusted);

    self.widthWhole.subscribe(function(newValue) {
      self.widthDimension.dimension.valueWhole(newValue);
    });
    self.heightWhole.subscribe(function(newValue) {
      self.heightDimension.dimension.valueWhole(newValue);
    });
    self.isLoadingPrices = ko.observable(false);

    self.onDimensionsChanged = function (data, e) {
      self.publishDimensionsChangedEvent();
      self.updatePrice(data, e);
      self.dimensionsAdjustedByServer(false);
    };

    productPageChannel.subscribe( "updatePrice", function ( data ) {

      self.updatePrice();
    });

    self.updatePrice = function (data, e, callback) {



      var params = buildPricingContext();
      if (SamePricingContext(params)) {
        return;
      }

      self.oldPricingContext = params;

      var vendorToken = sessionStorage.getItem('vendorToken');
      var reqHeaders = {
        url: globals.paths.loadSiteProductPricing,
        type: "GET",
        contentType: "application/json; charset=utf-8",
        data: {
          context: JSON.stringify(params)
        }
      };
      if(vendorToken && vendorToken.length>0)
      {
        reqHeaders=  _.extend(reqHeaders, {headers:{'vendor-token':vendorToken}});
      }

      $.ajax(reqHeaders).done(function (data, status, xhr) {
        self.lowPrice("N/A");
        self.highPrice( "N/A" );
        if (data.Data.LowerEstimate != null && data.Data.UpperEstimate != null) {
          if (data.Data.LowerEstimate > 0) {
            self.lowPrice(data.Data.LowerEstimate.toFixed(2));
          }
          if (data.Data.UpperEstimate > 0) {
            self.highPrice(data.Data.UpperEstimate.toFixed(2));
          }
          xhr.status = "success";
        } else {
          xhr.status = "failure";
        }

      }).always(function () {
        if ($.isFunction(callback)) {
          callback();
        }
      }).fail(function () {
        self.lowPrice("N/A");
        self.highPrice("N/A");
      });
    };

    var buildPricingContext = function () {
      var localPersistance = new LocalStorage();
      var savedState = localPersistance.getFromLocalStorage("option-state-" + self.productId);
      if (savedState) {
        var selectedChoices = JSON.parse(savedState);
        var selectedChoiceIds = [];
        _.each(selectedChoices, function(sc) {
          // Add to the collection only the sampleable choices
          if (sc.id !== self.widthOption.ChoiceId && sc.id !== self.heightOption.ChoiceId) {
            selectedChoiceIds.push(sc.id);
          }
        });
      }

      var params = {
        "ProductId": self.productId,
        "Choices": [],
        "ForContextOnly": true
      };

      // Width
      if (self.widthOption !== null) {
        params.Choices.push({
          ChoiceId: self.widthOption.ChoiceId,
          OptionId: self.widthOption.OptionId,
          OptionType: "width",
          ChoiceValue: self.widthDimension.dimension.value(),
          ChoiceDataType: "DimensionInchesEighth"
        });
      }

      // Height
      if (self.heightOption !== null) {
        params.Choices.push({
          ChoiceId: self.heightOption.ChoiceId,
          OptionId: self.heightOption.OptionId,
          OptionType: "height",
          ChoiceValue: self.heightDimension.dimension.value(),
          ChoiceDataType: "DimensionInchesEighth"
        });
      }

      // Samples (mostly colors)
      if ( selectedChoiceIds ) {
          _.each( self.sampleOptions.Options, function ( sampleOption ) {
          var optionType = sampleOption.Type ? sampleOption.Type.replace(" ", "").toLowerCase() : "";
          _.each(sampleOption.Groups, function(group) {
            _.each(group.Choices, function(choice) {
              if (_.contains(selectedChoiceIds, choice.ChoiceId)) {
                params.Choices.push({
                  ChoiceId: choice.ChoiceId,
                  OptionId: sampleOption.OptionId,
                  OptionType: optionType,
                  ChoiceValue: true,
                  ChoiceDataType: "List"
                });
                var index = selectedChoiceIds.indexOf(choice.ChoiceId);
                if (index > -1) selectedChoiceIds.splice(index, 1);
              }

              if (!selectedChoiceIds.length) {
                return params;
              }
            });
          });
        });
      }
      return params;
    };

    var getSampleOptionIds = function() {

      // Samples (mostly colors)
      var params = [];
      _.each(self.sampleOptions, function(sampleOption) {
        params.push(sampleOption.OptionId);
      });

      return params;
    };

    var SamePricingContext = function(newPricingContext) {
      if (self.oldPricingContext && newPricingContext) {
        if (self.oldPricingContext.ProductId === newPricingContext.ProductId &&
          self.oldPricingContext.ForContextOnly === newPricingContext.ForContextOnly &&
          self.oldPricingContext.Choices.length === newPricingContext.Choices.length) {
          for (var i = 0, j = newPricingContext.Choices.length; i < j; i++) {
            var newChoice = newPricingContext.Choices[i];
            var oldChoice = self.oldPricingContext.Choices[i];
            if (newChoice.ChoiceId !== oldChoice.ChoiceId ||
                newChoice.OptionId !== oldChoice.OptionId ||
                newChoice.OptionType !== oldChoice.OptionType ||
                newChoice.ChoiceValue !== oldChoice.ChoiceValue) {
              return false;
            }
          }
          return true;
        }
      }
      return false;
    };

    self.publishDimensionsChangedEvent = function () {
      postal.publish({
        topic: "dimensions.changed",
        data: {
          pricingContext: buildPricingContext(),
          optionIds: getSampleOptionIds(),
          productId: self.productId,
          width: self.widthDimension,
          height: self.heightDimension
        }
      });
    };

    //usage numericPrice: field
    //if there is a decimal portion, show two decimal places.  If not, show 0 decimal places.
    ko.bindingHandlers.numericPrice = {
      update: function(element, valueAccessor, allBindingsAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor()),
          precision = value % 1 === 0 ? 0 : 2,
          formattedValue = value.toFixed(precision);

        ko.bindingHandlers.text.update(element, function() { return formattedValue; });
      },
      defaultPrecision: 1
    };

  };

  return EstimateProductPriceViewModel;

});
